import type {
  MachineDetailDto,
  RouterMachinesResponse,
} from "../../../domain/types/machine";
import { RouterMachinesResponseSchema } from "../../../domain/types/machine";
import { MachineDetailDtoSchema } from "../../../domain/types/machine";
import type { AdminMachineRepository } from "../../../domain/repositories/admin/admin-machine-repository";
import { adminMachineApiService } from "../../api/admin/admin-machine-api-service";

export class AdminMachineRepositoryImpl implements AdminMachineRepository {
  async getMachines(companyId: number): Promise<MachineDetailDto[]> {
    const response = await adminMachineApiService.getMachines(companyId);

    if (response.data) {
      console.log(response.data);
      return response.data.map((machine) =>
        MachineDetailDtoSchema.parse(machine),
      );
    }

    throw new Error(response.errorMsg || "기계 불러오기 실패.");
  }

  async getMachineDetailsByRouter(
    companyId: number,
  ): Promise<RouterMachinesResponse[]> {
    const response = await adminMachineApiService.getMachineDetailsByRouter(companyId);

    if (response.data) {
      return response.data.map((item) =>
        RouterMachinesResponseSchema.parse(item),
      );
    }

    throw new Error(response.errorMsg || "기계 불러오기 실패.");
  }
}
